/* eslint-disable no-undefined */
import React from "react";
import { useField } from "formik";
import Grid, { GridSize } from "@material-ui/core/Grid";

import { passes } from "pages/eligibility/validations";
import { Handle, QuestionType } from "pages/eligibility/type";
import styles from "./form.module.css";
import { types as QuestionVariants } from "./fields";
import { keyFromIdentity, formatChildren } from "./helpers";

const MissingQuestion = (props: any) => {
  // eslint-disable-next-line no-console
  console.error(`Rendering question as MissingQuestion ${props.__typename}`);
  return props.__typename;
};

type QuestionProps = Handle<any> & {
  questionsMap?: any;
  children: string[][];
  variant?: "root" | "child";
  title: string;
  __typename: QuestionType;
  identity: string[];
  data?: any;
  parent?: string;
  index?: number;
}
export { QuestionProps };

const getSizes = ({ variant, parent, data }: QuestionProps):
{ sm: GridSize, lg: GridSize } => {
  if ((data && data.message) || parent) {
    return { sm: 12, lg: 12 };
  }
  const sm = 12;
  const lg = (variant === "root" ? 8 : 12);
  return { sm, lg } as { sm: GridSize, lg: GridSize };
};

type ContainerProps = {
  sm: GridSize;
  lg: GridSize;
  container?: boolean;
  spacing?: 0 | 1;
  alignContent?: "flex-start";
}

const getProps = (props: QuestionProps, container: boolean): ContainerProps =>
  (container ? {
    ...getSizes(props),
    container,
    spacing: 1,
    alignContent: "flex-start",
  } : getSizes(props));


const Question = (props: QuestionProps): React.ReactElement | null => {
  const { __typename, children, identity, questionsMap, parent, index } = props;
  const filteredProps = { ...props };
  delete filteredProps.variant;

  const QuestionVariant = QuestionVariants[__typename] || MissingQuestion;

  const name = keyFromIdentity(identity, parent, index);
  const [, { value }] = useField(name);

  const filteredChildren =
    formatChildren(children, questionsMap)
      .filter(({ params } : { params: Handle<any>; }) => passes(params, value));

  const container = !!filteredChildren.length;
  const gridProps = getProps(props, container);

  return (
    <Grid
      item
      container={container}
      xs={12}
      {...gridProps}
    >
      {container ? (
        <Grid item xs={12}>
          <QuestionVariant
            {...filteredProps}
            className={styles.question} questionsMap={questionsMap} name={name} />
        </Grid>) : (
        <QuestionVariant
          {...filteredProps}
          className={styles.question} questionsMap={questionsMap} name={name} />
      )}
      {filteredChildren
        .map(({ key, params } : { key: string; params: Handle<any>; }) =>
          <Question key={key} {...filteredProps} {...params} questionsMap={questionsMap} />)}
    </Grid>
  );
};

export default Question;
